import React, { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useDropdown } from 'core/hooks/useDropdown';
import { scrollToElement } from 'core/utils/helpers/scrollToElement';

import { triggerPsrApplyFilterGaEvent } from 'core/modules/ProductSearchResults/actions';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import {
  EXTRA_REWARDS_FILTER, SALE_FILTER, EXTRA_REWARDS_FILTER_ID, SALE_FILTER_ID,
} from 'core/modules/ProductSearchResults/utils/keys';
import { selectProductSearchResultsConfig } from 'core/modules/ProductSearchResults/selectors';

function FilterMobile({ filterHook }) {
  const dispatch = useDispatch();
  const filterRef = useRef();
  const { toggleSubnav, isFocused } = useDropdown(filterRef);
  const { toggleIdInFilter, checkIsIdAddedToFilter } = filterHook;

  const { filterOptions } = useSelector(selectProductSearchResultsConfig);
  const { promotionsTitle, extraRewardsName, saleName } = filterOptions;

  const handleOnToggleIdChange = (facetName, id) => {
    scrollToElement(document.body, 0);
    toggleIdInFilter(facetName, id);

    const isAddedToFilter = !checkIsIdAddedToFilter(facetName, id);
    dispatch(triggerPsrApplyFilterGaEvent(facetName, isAddedToFilter));
  };

  return (
    <div ref={filterRef} className="mn_filter mn_psrMobileFilter">
      <button className="mn_filterTitle" onClick={toggleSubnav} aria-expanded={isFocused}>
        {promotionsTitle}
      </button>
      { isFocused &&
        <div className="mn_filterDropdown">
          <ul>
            <li>
              <label>
                <input
                  type="checkbox"
                  onChange={() => handleOnToggleIdChange(EXTRA_REWARDS_FILTER, EXTRA_REWARDS_FILTER_ID)}
                  checked={checkIsIdAddedToFilter(EXTRA_REWARDS_FILTER, EXTRA_REWARDS_FILTER_ID)}
                />
                <span className="mn_name">{extraRewardsName}</span>
              </label>
            </li>
            <li>
              <label>
                <input
                  type="checkbox"
                  onChange={() => handleOnToggleIdChange(SALE_FILTER, SALE_FILTER_ID)}
                  checked={checkIsIdAddedToFilter(SALE_FILTER, SALE_FILTER_ID)}
                />
                <span className="mn_name">{saleName}</span>
              </label>
            </li>
          </ul>
        </div>
      }
    </div>
  );
}

export default (props) => <ComponentErrorBoundary><FilterMobile {...props} /></ComponentErrorBoundary>;
